{
  "es": {
    "profile": {
      "actions": {
        "changeEmail": "Cambiar correo",
        "changeEmailAddress": "Cambiar correo",
        "delete": "Eliminar",
        "installApp": "Instalar app 🚀",
        "launchApp": "Abrir app",
        "save": "Guardar",
        "showQRCode": "Mostrar código QR"
      },
      "attributes": {
        "decimal_separator": "Notación decimal de la moneda",
        "email_address": "Correo electrónico",
        "email_address_new": "Nuevo correo electrónico",
        "email_address_old": "Correo electrónico anterior"
      },
      "labels": {
        "addToHomeScreen": "Añadir a la pantalla de inicio",
        "allowAccess": "Da acceso a Ziggu a tu cuenta",
        "allowImpersonation": "Permitir el acceso de Ziggu",
        "allowImpersonationSubtext": "Es posible que necesitemos acceder temporalmente a tu cuenta para diagnosticar y resolver un problema de soporte que hayas planteado. Nuestro acceso caduca automáticamente a los 7 días.",
        "allowRecording": "Permitir la grabación de la sesión",
        "allowRecordingSubtext": "Grabar tu sesión en Ziggu puede ayudarnos a encontrar la causa raíz de un problema que hayas planteado. La grabación se detiene automáticamente a los 60 minutos o cuando desactives este ajuste.",
        "and_x_other": "y 1 más | y {other_count} más",
        "bulk_invite_help": "Invitaremos a los contactos seleccionados a la plataforma. Esto puede tardar unos minutos.",
        "changeEmailAddress": "Cambiar correo de {profile_name}",
        "checkYourInbox": "Te hemos enviado un correo a {email_address} para confirmar",
        "confirmEmailUpdate": "El correo contiene un enlace para completar el proceso de actualización. Contáctanos si tienes algún problema.",
        "confirmPasswordReset": "Se ha enviado un correo con un enlace para restablecer tu contraseña; revisa tu bandeja de entrada. Contáctanos si tienes algún problema.",
        "currency": {
          "comma": "Coma: 200.450,99",
          "point": "Punto: 200,450.99"
        },
        "emailAddressNewConfirm": "Confirmar nuevo correo electrónico",
        "emailNotificationsInterval": "Frecuencia de correos para nuevas notificaciones",
        "emailNotificationsIntervalSubtext": "Aquí puedes configurar con qué frecuencia quieres que la plataforma compruebe si hay actualizaciones para ti y te envíe un correo al respecto.",
        "explainerSendEmail": "Se enviará un nuevo correo de invitación a {name}",
        "explainerUpdateEmailActive": "{name} ya está activo en la plataforma. Se enviará un correo a la nueva dirección con un enlace para confirmar el cambio de correo.",
        "explainerUpdateEmailInvited": "{name} ya ha sido invitado. Se enviará una nueva invitación a la nueva dirección de correo. Las invitaciones anteriores dejarán de funcionar.",
        "followDevicePrompts": "Sigue las indicaciones de tu dispositivo para añadir la app a la pantalla de inicio",
        "impersonateProfile": "Suplantar a {profile_name}",
        "important": "Importante",
        "importantContent": "Asegúrate de haber iniciado sesión en la plataforma desde el navegador web de tu dispositivo móvil.",
        "installMobileApp": "Instalar app móvil",
        "logInMobileDevice": "Inicia sesión en tu dispositivo móvil",
        "maintainerCannotImpersonatePartner": "Solo los empleados con el rol de 'Propietario' pueden suplantar a colaboradores.",
        "maintainerCannotUpdateEmailAddress": "Solo los empleados con el rol de 'Propietario' pueden actualizar el correo",
        "multipleProfiles": "Este usuario tiene varios perfiles de Ziggu. Solo el usuario puede cambiar el correo.",
        "mustBeLoggedInBeforeQR": "Debes haber iniciado sesión en tu dispositivo móvil antes de escanear el código QR",
        "noEmailAddressAdded": "Sin correo añadido",
        "onceLoggedInScan": "Una vez que hayas iniciado sesión, escanea el código QR para instalar la app en tu dispositivo",
        "openMobileBrowser": "Abre el navegador de tu móvil y visita",
        "public_api_access": "Token de acceso a la API pública",
        "redirectAutomatically": "Serás redirigido automáticamente en {seconds} segundos",
        "requestPasswordReset": "Restablecer contraseña",
        "scanQRCode": "Escanea el código QR",
        "toLogInCredentials": "para iniciar sesión con tus credenciales",
        "updateEmailFailed": "No se ha podido actualizar tu correo. Inténtalo de nuevo o contáctanos.",
        "updateEmailSuccessful": "Tu correo se ha actualizado correctamente",
        "updateFailed": "La actualización ha fallado. Inténtalo de nuevo o contáctanos."
      },
      "notifications": {
        "avatarChangedSuccessfully": "El avatar se ha actualizado. Los cambios pueden tardar hasta una hora en ser visibles."
      },
      "toasts": {
        "bulk_invite": "Hemos empezado a invitar a los contactos seleccionados a la plataforma",
        "emailResendSuccessfully": "Correo reenviado correctamente"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "La dirección de correo no existe o ha dejado de existir; cambia el correo.",
          "illegal_address": "Dirección de correo no válida: es posible que el correo que has indicado no esté configurado correctamente; asegúrate de que el correo tiene el formato adecuado y no contiene caracteres no permitidos.",
          "isp_block": "Bloqueo del ISP: un bloqueo suele significar que nuestra dirección IP o servidor ha sido rechazado por el servidor de correo receptor.",
          "soft_bounce": "La persona está fuera de la oficina, o el buzón está lleno y no acepta correos.",
          "spam_complaint": "La persona ha marcado el correo como \"spam\" en su cliente de correo, por lo que esta dirección se ha desactivado. Si el destinatario se pone en contacto contigo y quiere volver a recibir correos, contáctanos.",
          "spam_notification": "El servidor de correo ha rechazado los correos. Esto puede deberse a políticas corporativas estrictas en el servidor receptor o a que algunas palabras de tu correo han sido marcadas por los filtros de spam."
        },
        "emailAddressBounced": "Error en el correo",
        "emailDoesntMatch": "El correo no coincide",
        "emailTaken": "Este correo ya está en uso. Si aun así quieres hacer este cambio, contáctanos por el chat.",
        "mustBeEmailAddress": "Se requiere un correo válido",
        "requireEmailAddress": "El correo es obligatorio",
        "tooManyRequests": "Solo se permite un cambio de correo cada 5 minutos. Inténtalo de nuevo más tarde."
      }
    }
  }
}
